// generated by genversion
export var version = '4.0.1';
//# sourceMappingURL=version.js.map